import { InstallationMenuItemNew } from "../../../../shared/sidebar/sidebar-installations-menu/models/installation-menu-item.model";
import { IInstallationMenuItem } from "../response/installation-menu-item.response";

export namespace InstallationsMapper {
    export const mapInstallationMenuItemResponse = (
        from: IInstallationMenuItem,
        to: InstallationMenuItemNew = new InstallationMenuItemNew()
    ): InstallationMenuItemNew => {
        Object.assign(to, from);
        to.children = from?.children?.map(d => mapInstallationMenuItemResponse(d)) ?? [];
        return to;
    };
    
    export const mapInstallationMenuItemsResponse = (
        models: IInstallationMenuItem[]
    ): InstallationMenuItemNew[] => {
        return models.map(item => mapInstallationMenuItemResponse(item));
    };
}